export default {
    // "defaultGameSlug": "ember"
    // "defaultGameSlug": "hero"
    "defaultGameSlug": "dice"
}
